module.exports = __webpack_public_path__ + "img/btn_tixian@2x.f1cd83ac.png";